// extracted by mini-css-extract-plugin
export var drawerPaper = "_2o-0";
export var itemCard = "_2o-1";
export var itemImage = "_2o-2";